import React, { Component } from "react"
import PropTypes from "prop-types"
import IconButton from "material-ui/IconButton"
import ActionSave from "material-ui/svg-icons/content/save"
import ActionCopy from "material-ui/svg-icons/content/content-copy"
import ActionPaste from "material-ui/svg-icons/content/content-paste"
import Paper from "material-ui/Paper"
import Toggle from "material-ui/Toggle"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import { Card, CardHeader, CardText } from "material-ui/Card"
import { Counter, BlockCounter, RTInput, TextInput } from "./components"
import { DivHeaderActions, DivTitle } from "./styled"
import { SketchColorPicker } from "../../../components"
import { RestApiCollections } from "../../../../restClient"

const toolbar = [
  [
    {
      font: [
        false,
        "serif",
        "Lato",
        "OpenSans",
        "Montserrat",
        "PlayfairDisplay",
        "RobotoCondensed",
      ],
    },
  ],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["blockquote", "code-block"],
  ["clean"],
]

const defaultHref = {
  url: "",
  target: "",
  isCollection: false,
  collection: 0,
}

//backgroundColor
class TextView extends Component {
  constructor(props) {
    super(props)
    const {
      text,
      backgroundColor,
      containerPadding,
      lineHeight,
      letterSpacing,
      isLink,
      href,
    } = props.data.values
    const lH = lineHeight.split("%").join("") * 1
    const lS = letterSpacing.split("px").join("") * 1
    const textLink = href ? href : defaultHref
    this.state = {
      isEditMode: false,
      expanded: true,
      expandedAction: false,
      value: text,
      backgroundColor: backgroundColor,
      oldValue: props.data,
      containerPadding: containerPadding,
      lineHeight: lH,
      letterSpacing: lS,
      isLink: isLink || false,
      href: textLink,
      collections: [],
    }
    // this.onChangeText = this.onChangeText.bind(this);
  }
  componentWillMount() {
    this.getCollectionsList()
  }

  getCollectionsList = () => {
    RestApiCollections()
      .then((response) => {
        return response.json()
      })
      .then((items) => {
        if (items && !items.messages) {
          this.setState({
            collections: items,
          })
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
  handleExpandChange = (expanded) => {
    this.setState({ expanded: expanded })
  }
  handleExpandActionChange = (expanded) => {
    this.setState({ expandedAction: expanded })
  }
  onChangeText = (valueHtml) => {
    this.setState({ value: valueHtml })
  }
  onClickSave = () => {
    let newData = this.props.data
    newData.values.text = this.state.value
    newData.values.backgroundColor = this.state.backgroundColor
    newData.values.containerPadding = this.state.containerPadding
    newData.values.lineHeight = this.state.lineHeight + "%"
    newData.values.letterSpacing = this.state.letterSpacing + "px"
    newData.values.isLink = this.state.isLink
    newData.values.href = this.state.href
    this.props.onUpdateData(newData)
  }
  onUpdateColor = (color) => {
    this.setState({ backgroundColor: color })
  }
  onUpdatePadding = (padding) => {
    this.setState({ containerPadding: padding })
  }
  onUpdateLineHeight = (value) => {
    this.setState({ lineHeight: value })
  }
  onUpdateLetterSpacing = (value) => {
    this.setState({ letterSpacing: value })
  }
  onClickCopy = () => {
    let newData = this.props.data
    newData.values.text = this.state.value
    newData.values.backgroundColor = this.state.backgroundColor
    newData.values.containerPadding = this.state.containerPadding
    newData.values.lineHeight = this.state.lineHeight + "%"
    newData.values.letterSpacing = this.state.letterSpacing + "px"
    newData.values.isLink = this.state.isLink
    newData.values.href = this.state.href
    localStorage.setItem("TextView", JSON.stringify(newData.values))
  }
  onClickPaste = () => {
    const textContent = JSON.parse(localStorage.getItem("TextView"))
    if (textContent) {
      const {
        text,
        backgroundColor,
        containerPadding,
        lineHeight,
        letterSpacing,
        isLink,
        href,
      } = textContent
      const lH = lineHeight.split("%").join("") * 1
      const lS = letterSpacing.split("px").join("") * 1
      const textLink = href ? href : defaultHref
      this.setState({
        value: text,
        backgroundColor: backgroundColor,
        oldValue: this.props.data,
        containerPadding: containerPadding,
        lineHeight: lH,
        letterSpacing: lS,
        isLink: isLink || false,
        href: textLink,
      })
      this.onChangeText(text)
    }
  }

  onToggleActionIsLink = (e, v) => {
    this.setState({ isLink: v })
  }
  onToggleActionCollection = (e, v) => {
    let collection = this.state.href
    collection.isCollection = v
    this.setState({ href: collection })
  }
  onChangeTarget = (event, index, value) => {
    const newValue = value === "_blank" ? value : ""
    let newHref = this.state.href
    newHref.target = newValue
    this.setState({
      href: newHref,
    })
  }
  onChangeTargetCollection = (event, index, value) => {
    let newHref = this.state.href
    newHref.collection = value
    this.setState({
      href: newHref,
    })
  }
  onUpdateUrl = (value) => {
    let newHref = this.state.href
    newHref.url = value
    this.setState({
      href: newHref,
    })
  }

  render() {
    const { target } = this.state.href
    const valueTarget = target === "_blank" ? target : "same"
    return (
      <div style={{ width: "100%" }}>
        <div style={{ width: "100%", overflowY: "scroll", height: 500 }}>
          <Paper style={styles.paper} zDepth={1}>
            <RTInput
              input={
                <input
                  type="text"
                  name="name"
                  value={this.state.value}
                  onChange={(value) => this.onChangeText(value)}
                />
              }
              source="body"
              label="Body"
              toolbar={toolbar}
            />
          </Paper>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expanded}
              onExpandChange={this.handleExpandChange}
            >
              <CardHeader
                title="General"
                subtitle="Content TextView"
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Line Height</DivTitle>
                  <Counter
                    onSetValue={(value) => this.onUpdateLineHeight(value)}
                    value={this.state.lineHeight}
                    interval={10}
                    subtitle="%"
                    minValue={100}
                  />
                </Paper>

                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Letter Spacing</DivTitle>
                  <Counter
                    onSetValue={(value) => this.onUpdateLetterSpacing(value)}
                    value={this.state.letterSpacing}
                    interval={1}
                    subtitle="px"
                    minValue={-5}
                  />
                </Paper>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Container Padding</DivTitle>
                  <BlockCounter
                    containerPadding={this.state.containerPadding}
                    onUpdatePadding={(containerPadding) =>
                      this.onUpdatePadding(containerPadding)
                    }
                  />
                </Paper>
                <Paper style={styles.paperText} zDepth={1}>
                  <SketchColorPicker
                    title={"Background"}
                    onUpdateColor={(color) => this.onUpdateColor(color)}
                    color={this.state.backgroundColor}
                  />
                </Paper>
              </CardText>
            </Card>
          </div>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expandedAction}
              onExpandChange={this.handleExpandActionChange}
            >
              <CardHeader
                title="Action"
                subtitle=""
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <Toggle
                  label="Use Link"
                  style={{ marginBottom: 10 }}
                  toggled={this.state.isLink}
                  onToggle={(e, v) => this.onToggleActionIsLink(e, v)}
                />
                {this.state.isLink && (
                  <div>
                    <SelectField
                      floatingLabelText="Target"
                      onChange={(event, index, value) =>
                        this.onChangeTarget(event, index, value)
                      }
                      value={valueTarget}
                      autoWidth={true}
                      name="target href"
                    >
                      <MenuItem value={"same"} primaryText="Same Page" />
                      <MenuItem value={"_blank"} primaryText="New Page" />
                    </SelectField>
                    <Toggle
                      label="Collection"
                      style={{ marginBottom: 10 }}
                      toggled={
                        this.state.href.isCollection
                          ? this.state.href.isCollection
                          : false
                      }
                      onToggle={(e, v) => this.onToggleActionCollection(e, v)}
                    />
                    {!this.state.href.isCollection && (
                      <TextInput
                        value={this.state.href.url}
                        onChange={(value) => this.onUpdateUrl(value)}
                        name="HrefUrl"
                        title="Url"
                        fullWidth={true}
                      />
                    )}
                    {this.state.href.isCollection && (
                      <SelectField
                        floatingLabelText="Using Collection link"
                        onChange={(event, index, value) =>
                          this.onChangeTargetCollection(event, index, value)
                        }
                        value={this.state.href.collection}
                        autoWidth={true}
                        name="target collection href"
                      >
                        {this.state.collections.map((item, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={item.id}
                              primaryText={item.name}
                            />
                          )
                        })}
                      </SelectField>
                    )}
                  </div>
                )}
              </CardText>
            </Card>
          </div>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    )
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10,
  },
  headerCard: {
    display: "flex",
    textAlign: "left",
  },
  paperCard: {
    margin: 10,
  },
  paperText: {
    padding: 10,
    marginBottom: 10,
  },
}

TextView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired,
}

TextView.defaultProps = {
  data: {},
}
export default TextView



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/TextView.js